import { render, staticRenderFns } from "./AssetTypesIndex.vue?vue&type=template&id=24b88136"
import script from "./AssetTypesIndex.vue?vue&type=script&lang=js"
export * from "./AssetTypesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports